module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "nav-mobile",
    class: {
      "nav-mobile--scrolling": _vm.$store.state.nav, "nav-mobile--notransparent": _vm.$route.path === "/"
    }
  }, [_c('div', {
    staticClass: "nav-mobile__container"
  }, [_c('div', {
    staticClass: "nav-mobile__item"
  }, [_c('router-link', {
    staticClass: "nav-mobile__logo-container",
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDrawer($event)
      }
    }
  }, [_c('Icon', {
    staticClass: "nav-mobile__logo",
    attrs: {
      "name": "matt_logo-01"
    }
  })], 1)], 1), _c('div', {
    staticClass: "nav-mobile__item"
  }, [_c('div', {
    staticClass: "nav-mobile__menu-container",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('div', {
    staticClass: "nav-mobile__hamburger",
    class: {
      "nav-mobile__hamburger--active": _vm.active
    }
  }, [_c('span'), _c('span')])])]), _c('transition', {
    staticClass: "nav-mobile__drawer-transition",
    attrs: {
      "name": "fade-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "nav-mobile__drawer",
    on: {
      "click": _vm.closeDrawer
    }
  }, [_c('div', {
    staticClass: "nav-mobile__drawer-container",
    on: {
      "click": _vm.closeDrawer
    }
  }, [_c('div', {
    staticClass: "nav-mobile__links"
  }, _vm._l((_vm.links), function(nav) {
    return (nav.navigation || nav.mobile) ? _c('span', {
      staticClass: "nav-mobile__link"
    }, [_c('router-link', {
      attrs: {
        "to": nav.path
      }
    }, [_vm._v(_vm._s(nav.name))])], 1) : _vm._e()
  }), 0), _c('Bottom'), _c('div', {
    staticClass: "nav-mobile__bottom"
  }, [_c('div', {
    staticClass: "nav-mobile__button-group"
  }, [_c('a', {
    staticClass: "nav-mobile__rewards",
    attrs: {
      "href": _vm.props.acf.links.rewards,
      "target": "_blank"
    }
  }, [_vm._v("Rewards Center")]), _c('a', {
    staticClass: "nav-mobile__login",
    attrs: {
      "href": _vm.props.acf.links.login,
      "target": "_blank"
    }
  }, [_vm._v("Patient Login")]), _c('router-link', {
    staticClass: "nav-mobile__videos",
    attrs: {
      "to": "/videos"
    }
  }, [_vm._v("Videos")])], 1), _c('div', {
    staticClass: "nav-mobile__icon-row"
  }, _vm._l((_vm.props.acf.social_links), function(link, i) {
    return _c('a', {
      key: i,
      staticClass: "nav-mobile__icon-wrapper",
      attrs: {
        "href": link.href,
        "target": "_blank"
      }
    }, [_c('Icon', {
      staticClass: "nav-mobile__icon",
      class: "nav-mobile__" + link.label,
      attrs: {
        "name": link.icon
      }
    })], 1)
  }), 0)])], 1)])])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d4ffa14","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/navigation/nav-mobile/nav-mobile.pug
// module id = 679
// module chunks = 1